export default "__VITE_ASSET__Dd_HB9zd__"